import { useState } from "react";
import Header from "../../commonComponents/header/Header";
import arrowImg from "../../../assets/images/arrow-white-icon.svg";
import moonshotsImg from "../../../assets/images/nh_consumer_snapshot_taking.svg";
import proctoringImg from "../../../assets/images/proctoring-icon.svg";
import { useNavigate } from "react-router-dom";
import LoadingDialog from "../../commonComponents/loader/LoadingDialog";
import CommonSnackbar from "../../commonComponents/snackbar/CommonSnackbar";

const MoonshotsTakingPictures = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState(null);

  const handleProceed = async () => {
    // Check if desktopAgent flag is set in sessionStorage
    const desktopAgent = sessionStorage.getItem("desktopAgent") === "true";
      const whiteboardFlag = sessionStorage.getItem("coding_env")=="true";
    const codingFlag = sessionStorage.getItem("whiteboarding_env")=="true";
    if (desktopAgent) {
      navigate("/needleeye-desktop-introduction");
    } else {
      
      if(codingFlag||whiteboardFlag)
      navigate("/demo-video");
    else
      navigate("/verification")
    }
    
  };

  return (
    <div className="flex flex-col min-h-screen bg-white overflow-x-hidden px-4 pt-4">
      <Header />

      {loading && (
        <LoadingDialog
          title="Verifying Sync-Code"
          bottomMsg="This will be just a moment..."
        />
      )}

      {snackbar && (
        <CommonSnackbar
          message={snackbar.message}
          type={snackbar.type}
          onClose={() => setSnackbar(null)}
        />
      )}

      {/* Main */}
      <div className="flex-1 flex flex-col md:flex-row items-center justify-center px-1 pt-5 max-w-9xl mx-auto">
        {/* Left Image */}
        <div className="w-full md:w-1/2 flex justify-center items-center px-4 md:px-6 lg:px-8">
          <img
            src={moonshotsImg}
            alt="moonshots"
            className="object-contain w-full max-w-[520px] h-auto rounded-3xl"
          />
        </div>

        {/* Divider */}
        <div className="hidden md:block self-stretch w-[1px] bg-dividerColor mx-4 my-[5%]" />

        {/* Right Text */}
        <div className="w-full md:w-1/2 flex flex-col justify-center px-4 sm:px-6 md:px-8 lg:px-10 mt-6 md:mt-0">
          <div className="max-w-[720px]">
            {/* Heading */}
            <h2
              className="font-semibold mb-4 leading-snug outer-font-color
              app-title"
            >
              Taking pictures with NeedleEye Mobile
            </h2>

            {/* Intro */}
            <p
              className="mb-4 leading-relaxed outer-font-color
              app-body"
            >
              During your assessment, from time to time, you will be prompted to
              take snapshots of your screen or surroundings. To take pictures,
              do the following:
            </p>

            {/* Steps */}
            <p className="mb-2 outer-font-color app-body">
              1. Bring up NeedleEye on your phone.
            </p>

            <p className="mb-4 outer-font-color app-body">
              2. Look for the{" "}
              <span className="font-medium">Proctoring Icon</span> and tap on
              it.
            </p>

            {/* Icon */}
            <div className="flex flex-col items-center gap-2 my-6">
              <img
                src={proctoringImg}
                alt="proctoring icon"
                className="w-12 sm:w-14 md:w-16"
              />
              <p className="app-body text-gray-600">Proctoring Icon</p>
            </div>

            <p className="mb-4 outer-font-color app-body">
              3. A Camera Preview with a button will come up on the screen. Let
              this screen be active throughout your assessment.
            </p>

            <p className="outer-font-color app-body">
              4. Click a snapshot whenever you are prompted during assessment.
            </p>

            {/* Note */}
            <p className="mt-8 text-gray-600 italic app-note">
              Note: Taking a snapshot will automatically submit the picture.
            </p>
          </div>
        </div>
      </div>

      {/* Button */}
      <div className="mt-auto w-full flex justify-end pb-4 pr-4">
        <button
          onClick={handleProceed}
          className="btn-size flex bg-btnBgColor items-center px-6 py-1.5 text-white text-[16px]"
        >
          Proceed
          <img src={arrowImg} alt="arrow" className="ml-2" />
        </button>
      </div>

      {/* Footer */}
      <div className="w-full py-4 text-[10px] text-gray-600 text-center px-4">
     © {new Date().getFullYear() > 2026 ? `2026-${new Date().getFullYear()}` : '2026'}, Needles and Haystacks Technology Pvt Ltd.
      </div>
    </div>
  );
};

export default MoonshotsTakingPictures;
